import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import $ from "jquery";
import Creatable from "react-select/creatable";

const UpdateTKCSOrderDetails = ({
  size,
  getData,
  order_id,
  rowID,
  setRowId,
  party_name,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const navigate = useNavigate();
  const [tkcsOrder, setTkcsOrder] = useState({
    id: "",
    po_qty: "",
    circle: "",
    product_name: "",
    rate: 0,
    gst_percent: "",
  });
  const [circle, setCircle] = useState([]);
  const [circleRate, setCircleRate] = useState({ tkcs_rate: 0 });
  const [productSelect, setProductSelect] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "product_name") {
      setProductSelect(e.target.value);
    }
    setTkcsOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCircleChange = (selectedOption) => {
    setTkcsOrder((prev) => ({
      ...prev,
      circle: selectedOption ? selectedOption.value : "",
      product_name: "",
    }));
    setProductSelect("");
  };

  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setCircle((prev) => [...prev, newOption]);
    setTkcsOrder((prev) => ({
      ...prev,
      circle: inputValue,
    }));
  };

  const resetFields = () => {
    setTkcsOrder({
      id: "",
      po_qty: "",
      circle: "",
      product_name: "",
      rate: 0,
      gst_percent: "",
    });
    setRowId("");
    setProductSelect("");
  };

  const getSingleTkcsOrderDetails = async () => {
    const BASE_URL = `${SERVER_URL}/api/private-order/single-private-order-details/${user_id}/${rowID}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTkcsOrder(result.data);
    } else {
      setTkcsOrder(null);
    }
  };

  useEffect(() => {
    if (rowID) {
      getSingleTkcsOrderDetails();
    }
  }, [rowID]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const { id, po_qty, circle, product_name, rate, gst_percent } = tkcsOrder;

    const BASE_URL = `${SERVER_URL}/api/private-order/private-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        po_qty,
        circle,
        product_name,
        rate,
        gst_percent,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getCircle = async () => {
    const BASE_URL = `${SERVER_URL}/api/rate-list/circle-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      const combinedData = result.data.map((item) => ({
        value: item.circle,
        label: item.circle,
      }));
      setCircle(combinedData);
    } else {
      setCircle([]);
    }
  };

  useEffect(() => {
    getCircle();
  }, []);

  const getCircleRate = async () => {
    const BASE_URL = `/api/tkcs-rate/drop-tkcs-rate/${user_id}?party_name=${encodeURIComponent(
      party_name
    )}&product_name=${tkcsOrder?.product_name}&location=${encodeURIComponent(
      tkcsOrder?.circle
    )}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCircleRate(result.data || { tkcs_rate: 0 });
    } else {
      setCircleRate({ tkcs_rate: 0 });
    }
  };

  useEffect(() => {
    if (productSelect && tkcsOrder.circle) {
      getCircleRate();
    }
  }, [productSelect, circle, tkcsOrder.circle]);

  useEffect(() => {
    setTkcsOrder((prev) => ({
      ...prev,
      rate: circleRate.tkcs_rate,
    }));
  }, [circleRate]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update TKCS Order Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleUpdateDataSubmit}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Circle">Circle</label>
                            <Creatable
                              placeholder="Select or add circle"
                              onChange={handleCircleChange}
                              onCreateOption={handleCreateOption}
                              options={circle}
                              isSearchable
                              isClearable
                              required
                              value={
                                tkcsOrder.circle
                                  ? {
                                      value: tkcsOrder.circle,
                                      label: tkcsOrder.circle,
                                    }
                                  : null
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor={`product`}>Size</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleChange}
                              name="product_name"
                              value={tkcsOrder.product_name}
                              id={`product`}
                              required
                            >
                              <option value="">Select Product (All)</option>
                              {size &&
                                size.length > 0 &&
                                size.map((item, id) => (
                                  <option value={item.size} key={id}>
                                    {item.size}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="po_qty">
                              Offer Quantity For Inspection
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="po_qty"
                              id="po_qty"
                              placeholder="Offer Quantity For Inspection"
                              value={tkcsOrder.po_qty}
                              onChange={handleChange}
                              required
                              autoCapitalize="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="rate"
                              id="rate"
                              placeholder="Rate"
                              value={tkcsOrder.rate}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="gst">GST %</label>
                            <input
                              type="number"
                              className="form-control"
                              name="gst_percent"
                              id="gst"
                              placeholder="GST %"
                              value={tkcsOrder.gst_percent}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateTKCSOrderDetails;
